import React from 'react'
import WithUser from '../helpers/WithUser';
import Main from '../components/layouts/Main';
import Admin from '../components/layouts/Admin';
import Import from '../components/layouts/Import';
import Share from '../components/layouts/Share';
import Blank from '../components/layouts/Blank';
import Territories from '../components/layouts/Territories';

import { Route, Redirect, Switch } from 'react-router';

export default (
        
            <Switch>
                <Route path="/login" component={Blank} />
                <Route path="/share" component={Share} />
                <Route path="/admin" component={WithUser(Admin)} />
                <Route path="/import" component={Import} />
                <Route path="/territories" component={WithUser(Territories)} />
                <Route component={WithUser(Main)} />
            </Switch>
        
);